import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import type { WarehouseRecord } from '@/types/warehouse';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../requestOptions';

export const getWarehouse = async (
  scope: RequestScope,
  { id }: { id: number },
  options: ReadRequestOptions
): Promise<EndpointResponse<WarehouseRecord>> => {
  try {
    const response = await scopedApi(scope).get<EndpointResponse<WarehouseRecord>>(`warehouse/${id}`, options);
    return response.data;
  } catch (error) {
    return utils.error.handleAxiosError(error, { redactRequestData: true });
  }
};
